// extracted by mini-css-extract-plugin
export var input = "Input-module--input--3f434";
export var inputLabel = "Input-module--inputLabel--95d8c";
export var inputPrefix = "Input-module--inputPrefix--6af32";
export var inputWrapper = "Input-module--inputWrapper--3934e";
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var variant__overdraftCalculator = "Input-module--variant__overdraftCalculator--dadd1";
export var xsBreak = "480";